/**
 * Organization service, backed by Firestore (organisations/{domain}).
 * Doc IDs are email domains.
 */

import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';

let currentOrganization = null;

/**
 * Get current organization
 */
export const getCurrentOrganization = () => {
  return currentOrganization;
};

/**
 * Set current organization
 */
export const setCurrentOrganization = (organization) => {
  currentOrganization = organization;
};

const mapOrg = (orgId, data) => ({
  id: orgId,
  name: data.name || data.domain || orgId,
  createdAt: data.createdAt || null,
});

/**
 * Get organization by ID (the org's email domain)
 */
export const getOrganizationById = async (organizationId) => {
  try {
    const snap = await getDoc(doc(db, 'organisations', organizationId));
    if (!snap.exists()) {
      throw new Error('Failed to fetch organization');
    }
    return mapOrg(organizationId, snap.data());
  } catch (error) {
    console.error('Error fetching organization:', error);
    throw error;
  }
};

/**
 * Get all organizations (admin only; enforced by Firestore rules)
 */
export const getAllOrganizations = async () => {
  try {
    const snap = await getDocs(collection(db, 'organisations'));
    const orgs = [];
    snap.forEach((d) => orgs.push(mapOrg(d.id, d.data())));
    return orgs;
  } catch (error) {
    console.error('Error fetching organizations:', error);
    throw error;
  }
};
